<div *ngIf="item && item.cells" class="container flex flex-row justify-between items-center">

  <div class="flex flex-row justify-start items-center full-grow-no-shrink-no-basis" style="width: 0">
    <div class="full-grow-no-shrink-no-basis"
         title="{{item.cells[fieldDefinition.key] ? (item.cells[this.fieldDefinition.key].value?.toolTip ? item.cells[this.fieldDefinition.key].value?.toolTip : item.cells[fieldDefinition.key].displayText) : ''}}"
         [innerHTML]="item.cells[fieldDefinition.key] ? (item.cells[fieldDefinition.key].displayText | apiColourHtml) : '' | sanitizeHtml">
    </div>
  </div>

  <div *ngIf="item.cells['Icon']" class="flex flex-row justify-end items-center">
    <i class="{{item.cells['Icon'].value}}" [ngStyle]="{'color':item.cells['IconColor'].value | apiColour:'status'}"></i>
  </div>

</div>
